import { render, staticRenderFns } from "./OrderSectionTabs.vue?vue&type=template&id=519e164c&scoped=true&"
import script from "./OrderSectionTabs.vue?vue&type=script&lang=ts&"
export * from "./OrderSectionTabs.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSectionTabs.vue?vue&type=style&index=0&id=519e164c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e164c",
  null
  
)

export default component.exports